import { createRouter, createWebHashHistory } from "vue-router";
import { getCookie } from "@/utils/getCookie";
import { userinfo } from "@/common/api/http.api.login";
import { localCache } from "@/utils/Cache";
const routes = [
  {
    path: "/",
    redirect: "/client",
  },
  {
    path: "/error",
    name: "error",
    component: () => import("@/views/error"),
  },
  {
    path: "/loading",
    name: "loading",
    component: () => import("@/views/loading"),
  },
  {
    path: "/noperssion",
    name: "noperssion",
    component: () => import("@/views/noperssion"),
  },
  // 登录
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login"),
  },
  // 首页
  {
    path: "/client",
    name: "client",
    component: () => import("../views/Home"),
  },
  // 消息
  {
    path: "/message",
    name: "message",
    component: () => import("../views/messageManage/index"),
  },
  // 消息 待办列表
  {
    path: "/toDoList",
    name: "toDoList",
    component: () => import("../views/messageManage/component/toDoList"),
  },
  // 消息 通知公告列表
  {
    path: "/noticeList",
    name: "noticeList",
    component: () => import("../views/messageManage/component/noticeList"),
  },
  // 消息 通知公告详情
  {
    path: "/noticeDetails",
    name: "noticeDetails",
    component: () => import("../views/messageManage/component/noticeDetails"),
  }, // 消息 通知公告详情
  {
    path: "/recordDetails",
    name: "recordDetails",
    component: () => import("../views/messageManage/component/recordDetails"),
  },
  // 组织架构
  {
    path: "/organizationalStructure",
    name: "organizationalStructure",
    component: () =>
      import(
        "../views/mailList/component/organizationalStructure/organizationalStructure"
      ),
  },
  // 组织架构 子部门 人员信息
  {
    path: "/userData",
    name: "userData",
    component: () =>
      import("../views/mailList/component/organizationalStructure/userData"),
  },
  // 组织架构 子部门 人员信息 修改
  {
    path: "/modifyUserInfo",
    name: "modifyUserInfo",
    component: () =>
      import("../views/mailList/component/organizationalStructure/modifyInfo"),
  },
  // 组织架构 子部门 人员信息 详情
  {
    path: "/userDetails",
    name: "userDetails",
    component: () =>
      import("../views/mailList/component/organizationalStructure/userDetails"),
  },
  // 通讯录
  {
    path: "/mailList",
    name: "mailList",
    component: () => import("../views/mailList/index"),
  },
  // 个人中心
  {
    path: "/personalCenter",
    name: "personalCenter",
    component: () => import("../views/personalCenter/index"),
  },
  // 密码设置
  {
    path: "/modifyPassword",
    name: "modifyPassword",
    component: () =>
      import("../views/personalCenter/modifyPassword/modifyPassword"),
  },
  // 去注册
  {
    path: "/register",
    name: "register",
    component: () => import("../views/register/register"),
  },
  // 账号查询
  {
    path: "/accountQuery",
    name: "accountQuery",
    component: () => import("../views/accountQuery/accountQuery"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  let token = getCookie("sccp_platform");
  if (token) {
    userinfo({
      clientId: 1,
      accessToken: getCookie("sccp_platform"),
    }).then((res) => {
      if (res.code == 200) {
        localCache.setCache(
          "permissionList",
          JSON.stringify(res.data?.permissionList)
        );
        localCache.setCache("roleList", JSON.stringify(res.data?.roleList));
        localCache.setCache("userData", JSON.stringify(res.data?.userInfo));
        let roleCode = res.data?.roleList?.map((m) => m.roleCode);
        if (roleCode?.includes("super_admin")) {
          localCache.setCache("isAdmin", true);
        }
        localCache.setCache("collegeMoibleToken", res.data?.token);
        let routeList = router.options.routes[0];
        routeList.redirect = "/client";
      }
      next();
    });
  } else {
    if (to.path != "/login" && to.path != "/register" && to.path != "/accountQuery") {
      next("/login");
    } else {
      next();
    }
  }
});
export default router;
